import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Trans } from 'react-i18next'

import { Button, Divider, Loader, Message, Tab } from 'semantic-ui-react'
import { Mutation } from 'react-apollo'

import { findFeedsForApi } from '../../all_cards/aufschaltung.js'

import {
  MutationFeedActivate,
  MutationFeedDeactivate,
  QueryAllAufschaltungen } from '../../graphql'

class ApiWireqUrlBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeIndex: 0
    }
  }

  setActiveIndex (activeIndex) {
    if (this.state.activeIndex !== activeIndex) {
      this.setState({ activeIndex: activeIndex })
    }
  }

  onHandleTabChange = ({activeIndex}) => {
    this.setActiveIndex(activeIndex)
  }

  handleTabChange = ({activeIndex}) => {
    this.setActiveIndex(activeIndex)
  }

  renderContent (auid, feed, userVerified) {
    const isActivated = feed.is_activated
    const buttonTxt = isActivated ? <Trans>Deaktivieren</Trans> :
                                    <Trans>Aktivieren</Trans>
    const vars = {
      auid: auid,
      feed_id: feed.id
    }
    const nickname = feed.nickname

    const is_feed_activation_disabled = feed.is_activation_disabled
    const last_activation_change_reason = feed.last_activation_change_reason

    let reason
    if (!userVerified) {
      reason = <Trans i18nKey="wireq-unverified" nickname={nickname}>
        Ihr Feed der wireq-API «{{nickname}}» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.</Trans> 
    } else if (is_feed_activation_disabled) {
      reason = last_activation_change_reason === 'soft-expired' ?
      <Trans i18nKey="wireq-auto-expire" nickname={nickname}>Ihr Feed der wireq-API «{{nickname}}» wurde automatisch deaktiviert. Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.</Trans> :
      <Trans i18nKey="wireq-expired" nickname={nickname}>Ihr Feed der wireq-API «{{nickname}}» ist leider abgelaufen. <br />
        Kontaktieren Sie bitte unseren <NavLink exact to='/contact'>Kundenservice</NavLink>, wenn Sie an einer weiteren Belieferung interessiert sind.</Trans>
    }

    const is_activation_disabled = is_feed_activation_disabled || !userVerified
    const btn_disabled = (is_feed_activation_disabled &&
      last_activation_change_reason !== 'soft-expired') || !userVerified

    return (
      <Mutation mutation={MutationFeedActivate}
        awaitRefetchQueries={true}
        refetchQueries={[{query: QueryAllAufschaltungen}]}>
        {(feedActivate, {loading: loading1, error: error1}) => {
          return (
            <Mutation mutation={MutationFeedDeactivate}
              awaitRefetchQueries={true}
              refetchQueries={[{query: QueryAllAufschaltungen}]}>
              {(feedDeactivate, {loading: loading2, error: error2}) => {
                if (loading1 || loading2) return (<Loader active inline='centered' />)
                if (error1 || error2) return `Error ${error1} ${error2}`

                return (
                  <div>
                    {isActivated ?
                      <div>
                        <Message className='Message-url'>
                          <Message.Header>base-URL</Message.Header>
                          <p>{ feed.base_url }</p>
                        </Message>
                      </div>
                    :
                      is_activation_disabled ?
                      <p>
                        {reason}
                      </p> :
                      <p>
                        <Trans i18nKey="wireq-feed-inactive" nickname={nickname}>
                          wireQ-Feed für «{{nickname}}» ist noch nicht eingerichtet.
                          Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.
                        </Trans>
                      </p>}
                      <Divider />
                      <Button size='mini' floated='left' content={buttonTxt}
                        disabled={btn_disabled}
                        onClick={async () => {
                          isActivated
                            ? await feedDeactivate({ variables: vars })
                            : await feedActivate({ variables: vars })
                        }} />
                  </div>
                )
              }}
            </Mutation>
          )
        }}
      </Mutation>
    )
  }

  render () {
    const { activeIndex } = this.state
    const { context } = this.props
    const feeds = findFeedsForApi(context, 'wireq')
    const userVerified = context.userInfo && context.userInfo.email_verified
    if (!feeds) {
      return <div>Keine Ergebnisse</div>
    }
    return (
      <Tab menu={{ secondary: true, pointing: true, className: 'tab-wrapped'}} activeIndex={activeIndex}
        onTabChange={(e, {activeIndex}) => this.handleTabChange({activeIndex: activeIndex})}
        panes={feeds.map((f) => {
          return ({
            menuItem: f.nickname,
            render: () => this.renderContent(context.aufschaltung.auid, f, userVerified)
          })
        })
      } />
    )
  }
}

export { ApiWireqUrlBrowser }



// WEBPACK FOOTER //
// ./src/components/cards/ApiWireqUrlBrowser.js